import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { SecretKindEnum } from '../SecretKindEnum'
import type { SecretStatus } from './GetSecretStatusArgs'

@InputType()
export class SetSecretArgs extends ActionArgs {
  @Field(() => SecretKindEnum)
  kind: SecretKindEnum

  /** Field name to plaintext value; an empty string removes the field. Write-only: never returned. */
  @Field(() => GraphQLJSON)
  secrets: Record<string, string>
}

export interface ISetSecret extends IAction<SecretStatus, SetSecretArgs> {}
